import { AttachmentModel } from '../../app-lite/attachments/models/attachment';

interface AddUnitAttachmentToAdvertisingScope extends ng.IScope {
  advertising         : any;
  attachment          : AttachmentModel;
  save                : () => void;
  vehicle_advertising : any;
}

export function AddUnitAttachmentToAdvertisingCtrl (
  $scope             : AddUnitAttachmentToAdvertisingScope,
  $uibModalInstance  : ng.ui.bootstrap.IModalInstanceService,
  $translate         : ng.translate.ITranslateService,
  attachment         : AttachmentModel,
  advertising        : any,
  messages           : any,
  vehicle_advertising: any,
  workshopAPI        : any
) {
  $scope.advertising         = advertising;
  $scope.attachment          = attachment;
  $scope.vehicle_advertising = vehicle_advertising;

  $scope.save = function () {
    return workshopAPI.patch('/vehicle_attachment/update_attachment_for_advertising', $scope.attachment, 'vehicle_attachment')
    .then(() => {
      $uibModalInstance.close();

      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.IMAGE_ADVERTISING_SETTINGS'), 'success');
    });
  };
}
